import { makeStyles } from 'tss-react/mui';

// Constants
import { UNAVAILABLE_IMAGE_OPACITY } from '../../../../constants/ui';

export const useStyles = makeStyles()(
  (
    theme,
    { isKiteUser, isTabletMode, isMobileMode, isUnavailableForOrder } = {},
  ) => ({
    header: {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      width: 'fit-content',
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          fontSize: 24,
        }),
      },
    },
    blockHeader: {
      color: 'black',
    },
    stockNumber: {
      color: theme.palette.darkGrey,
    },
    productInfoHeader: {
      fontWeight: isKiteUser ? '700' : '600',
      marginBottom: theme.spacing(1),
      color: theme.palette.darkGrey,
    },
    productInfoText: {
      fontWeight: '400',
      color: theme.palette.darkGrey,
    },
    qtyInfoText: {
      color: isKiteUser ? theme.palette.primary1 : theme.palette.primary2,
      fontWeight: '700',
      fontSize: '18px',
      lineHeight: '24px',
    },
    outOfStockText: {
      fontWeight: isKiteUser ? '700' : '600',
      color: '#C5203F',
    },
    myRating: {
      fontWeight: isKiteUser ? '700' : '600',
      color: '#929A92',
    },
    leftPart: {
      height: 'fit-content',
    },
    qtyBlock:
      !isMobileMode && isTabletMode
        ? {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }
        : {},
    rightPart: {
      [theme.breakpoints.down('lg')]: {
        paddingTop: 83.5,
      },
      [theme.breakpoints.down('md')]: {
        paddingTop: 0,
      },
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      '& img': {
        objectFit: 'contain',
        width: '100%',
        opacity: isUnavailableForOrder ? UNAVAILABLE_IMAGE_OPACITY : 1,
      },
    },
  }),
);
